import {Component, OnInit} from '@angular/core';
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private matIconRegistry: MatIconRegistry,
              private domSanitizer: DomSanitizer) {
    this.matIconRegistry.addSvgIcon('app_edit', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/edit.svg"));
    this.matIconRegistry.addSvgIcon('app_comment', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/comment.svg"));
    this.matIconRegistry.addSvgIcon('app_info', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/oinfo.svg"));
    this.matIconRegistry.addSvgIcon('app_samples', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/samples.svg"));
    this.matIconRegistry.addSvgIcon('app_trash', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/trash.svg"));
    this.matIconRegistry.addSvgIcon('app_loading', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/loading.svg"));
    this.matIconRegistry.addSvgIcon('app_suppliers', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/icon_suppliers.svg"));
    this.matIconRegistry.addSvgIcon('app_analysis', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/icon_analysis.svg"));
    this.matIconRegistry.addSvgIcon('app_reports', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/icon_reports.svg"));
    this.matIconRegistry.addSvgIcon('app_location', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/icon_location.svg"));
    this.matIconRegistry.addSvgIcon('app_phone', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/icon_phone.svg"));
    this.matIconRegistry.addSvgIcon('app_mail', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/icon_envelope.svg"));
  }

  ngOnInit() {
  }
}
